export enum Languages {
  ca = 'ca',
  en = 'en',
  es = 'es',
}

export const LanguageList: Languages[] = [
  Languages.ca,
  Languages.en,
  Languages.es,
];

export const DEFAULT_LANGUAGE: Languages = Languages.ca;

